// @ts-nocheck

import { createSelector } from 'reselect';

import { getOutcomeIdsFromProps } from '../../../../selectors/_propsGetters_';
import { selectEntitiesOutcomes } from '../../../../selectors/entities/outcomes/entitiesOutcomesPrimary.selector';

export const selectOutcomesByOutcomesIdsProps = createSelector(
  [selectEntitiesOutcomes, getOutcomeIdsFromProps],
  (outcomes, outcomeIds) => {
    return outcomeIds?.map((id) => outcomes[id]) || [];
  },
);
